var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"color":"primary","large":"","dark":""}},on),[_vm._v(" "+_vm._s(_vm.label)+" "),_c('v-icon',[_vm._v("mdi-chevron-down")])],1)]}}])},[_c('MenuList',{attrs:{"items":_vm.items},on:{"select":_vm.handleSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }